type TextPart = { type: 'text'; content: string };

/** Joins the text parts of a message's content into a single string. */
export const getMessageText = (content: readonly { type: string }[]): string =>
  content
    .filter((p): p is TextPart => p.type === 'text')
    .map((p) => p.content)
    .join('\n');
